import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      try {
        const data = await api.postSession(sessionId);
        if (data.session_token) localStorage.setItem("session_token", data.session_token);
        setUser(data.user);
        // Clear hash
        window.history.replaceState(null, "", window.location.pathname);
        // 17-C item 6: return-to-join round trip (see Login.finishAuth).
        let joinId = null;
        try { joinId = sessionStorage.getItem("civic_return_join"); } catch { /* ignore */ }
        if (!data.user?.onboarded) {
          navigate("/onboarding", { replace: true, state: { user: data.user } });
        } else if (joinId) {
          navigate(`/collectives/${joinId}`, { replace: true });
        } else {
          navigate("/dashboard", { replace: true, state: { user: data.user } });
        }
      } catch (e) {
        console.error("Auth callback failed", e);
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream">
      <div className="text-forest font-display text-xl">Signing you in…</div>
    </div>
  );
}
